import gql from 'graphql-tag'

export const CREATE_CHANNEL = gql`
  mutation CreateChannel(
    $scope: String!
    $targetId: Int
    $provider: String!
    $channelType: String!
    $phoneNumber: String
    $credentials: JSONString
    $assignedMemberIds: [Int]
    $isActive: Boolean
  ) {
    createChannel(
      scope: $scope
      targetId: $targetId
      provider: $provider
      channelType: $channelType
      phoneNumber: $phoneNumber
      credentials: $credentials
      assignedMemberIds: $assignedMemberIds
      isActive: $isActive
    ) {
      channel {
        id
        provider
        channelType
        phoneNumber
        webhookToken
        assignedMemberIds
        isActive
        credentials
        webhookUrlTwilio
        webhookUrlBotmaker
      }
      success
      error
    }
  }
`

export const DELETE_CHANNEL = gql`
  mutation DeleteChannel($id: Int!) {
    deleteChannel(id: $id) {
      success
      error
    }
  }
`

export const TEST_TWILIO_CREDENTIALS = gql`
  mutation TestTwilioCredentials($accountSid: String!, $authToken: String!) {
    testTwilioCredentials(accountSid: $accountSid, authToken: $authToken) {
      success
      accountName
      error
    }
  }
`
